import {Component, OnInit, Input } from '@angular/core';
import { BarcodesVerificationModel, Enum_SoudotecBarcodesVerificationStatus } from '../barcodes-verification.model';
import { Model_SoudotecDocument } from '../../soudotec.models';

@Component({
    selector: 'abw-barcodes-verification-result',
    templateUrl: './barcodes-verification-result.component.html',
    styleUrls: ['./barcodes-verification-result.component.scss']
})
export class BarcodesVerificationResultComponent implements OnInit {
	@Input() model: BarcodesVerificationModel;
    @Input() value: Model_SoudotecDocument;
    Enum_SoudotecBarcodesVerificationStatus = Enum_SoudotecBarcodesVerificationStatus;

    constructor(
    ) {
    }

    ngOnInit() {
        console.log(this.value);
    }
}